module.exports = __webpack_public_path__ + "img/album16_06.bb4f031b.jpg";